// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Init plugin
export default (Vue) => {
  Vue.use(Loading)
  Vue.component('loading', Loading)
}
